import request from '@/utils/request2'

// 获取资源分组列表
export function getResourceList(params) {
  return request({
    url: '/cloud/delivery/resource/group/list',
    method: 'GET',
    params
  })
}
// 更新资源分组
export function editMaterial(data) {
  return request({
    url: `/cloud/delivery/resource/group/update`,
    method: 'POST',
    data
  })
}

// 删除资源分组
export function delMaterial(id) {
  return request({
    url: `/cloud/delivery/resource/group/delete/${id}`,
    method: 'POST'
  })
}

// 创建资源分组
export function addMaterial(data) {
  return request({
    url: `/cloud/delivery/resource/group/create`,
    method: 'POST',
    data
  })
}

// 创建单个资源（1-文件 2-视频 3-音频 4-图片）
export function resourceCreate(data) {
  return request({
    url: `/cloud/delivery/resource/create/single`,
    method: 'POST',
    data
  })
}

// 删除资源
export function deleteResource(id) {
  return request({
    url: `/cloud/delivery/resource/delete/${id}`,
    method: 'POST'
  })
}

// 获取单个资源详情（1-文件 2-视频 3-音频 4-图片）
export function getResourcesingle(id) {
  return request({
    url: `/cloud/delivery/resource/detail/single/${id}`,
    method: 'GET'
  })
}

// 记录资源下载
export function resourceDownload(data) {
  return request({
    url: `/cloud/delivery/resource/download/record`,
    method: 'POST',
    data
  })
}

// 分页查询资源
export function resourcePage(data) {
  return request({
    url: `/cloud/delivery/resource/page`,
    method: 'POST',
    data
  })
}

// 获取资源统计信息
export function resourceStats(data) {
  return request({
    url: `/cloud/delivery/resource/stats`,
    method: 'post',
    data
  })
}

// 修改单个资源（1-文件 2-视频 3-音频 4-图片）
export function resourceEdit(data) {
  return request({
    url: `/cloud/delivery/resource/update/single`,
    method: 'POST',
    data
  })
}

// 记录资源浏览
export function resourceView(resourceId) {
  return request({
    url: `/cloud/delivery/resource/view/record/${resourceId}`,
    method: 'POST'
  })
}

// 创建朋友圈资源
export function momentCreate(data) {
  return request({
    url: `/cloud/delivery/resource/moment/create`,
    method: 'POST',
    data
  })
}

// 获取朋友圈详情
export function momentDetail(id) {
  return request({
    url: `/cloud/delivery/resource/moment/detail/${id}`,
    method: 'GET'
  })
}

// 修改朋友圈
export function momentUpdate(data) {
  return request({
    url: `/cloud/delivery/resource/moment/update`,
    method: 'PUT',
    data
  })
}

// 创建落地页资源
export function htmlCreate(data) {
  return request({
    url: `/cloud/delivery/resource/html/create`,
    method: 'POST',
    data
  })
}

// 获取落地页详情
export function htmlDetail(id) {
  return request({
    url: `/cloud/delivery/resource/html/detail/${id}`,
    method: 'GET'
  })
}

// 修改落地页
export function htmlUpdate(data) {
  return request({
    url: `/cloud/delivery/resource/html/update`,
    method: 'PUT',
    data
  })
}

